const TextImageCaptionButtons = document.querySelectorAll(
  '.TextImage-mediaCaptionButton',
)

if (TextImageCaptionButtons) {
  Array.prototype.forEach.call(
    TextImageCaptionButtons,
    function (captionButtonElement) {
      captionButtonElement.addEventListener('click', () => {
        const itemElement = document.querySelector(
          '#' + captionButtonElement.getAttribute('aria-controls'),
        )

        if (
          !captionButtonElement.getAttribute('aria-expanded') ||
          captionButtonElement.getAttribute('aria-expanded') == 'false'
        ) {
          captionButtonElement.setAttribute('aria-expanded', true)
          itemElement.classList.add('TextImage-media--captionExpanded')
        } else {
          captionButtonElement.setAttribute('aria-expanded', false)
          itemElement.classList.remove('TextImage-media--captionExpanded')
        }
      })
    },
  )
}
